export default __webpack_public_path__ + "static/media/check.ee65fb1d.svg";